import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-asterisk",
  "use": "icon-s-asterisk-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-asterisk\"><path fill-rule=\"evenodd\" d=\"M19.7068966 14.5172414 13.3448276 11 19.7068966 7.48275862 18.5689655 5.51724138 12.362069 9.29310345 12.5172414 2 10.1896552 2 10.3448276 9.29310345 4.13793103 5.51724138 3 7.48275862 9.36206897 11 3 14.5172414 4.13793103 16.4827586 10.3448276 12.7068966 10.1896552 20 12.5172414 20 12.362069 12.7068966 18.5689655 16.4827586z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol